import React from "react";
import LoginForm from "../../components/loginForm/LoginForm";

const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
